import { useContext } from "react";
import BorseContext from "../../context/borse";

const RequestOutcome = () => {
  const { labels, currentRequest } = useContext(BorseContext);

  return (
    <div className="borse-content__outcome">
      {
        {
          ASSIGNED: (
            <>
              <div
                className="app-content__text"
                dangerouslySetInnerHTML={{
                  __html: currentRequest?.refundAmount
                    ? currentRequest?.requestForMe
                      ? labels?.WELFARE_BORSE_WON_MSG_REFUND ||
                        "<p>Caro collega,<br/>siamo felici di comunicarti che grazie ai tuoi meriti e al tuo impegno, ti sei aggiudicato la borsa di studio <strong>e ti verrà inoltre riconosciuto il rimborso delle tasse universitarie</strong>.</p>"
                      : labels?.WELFARE_BORSE_WON_MSG_REFUND_CHILD ||
                        "<p>Ciao,<br/>siamo felici di comunicarti che grazie ai tuoi meriti e al tuo impegno, ti sei aggiudicato la borsa di studio <strong>e ti verrà inoltre riconosciuto il rimborso delle tasse universitarie</strong>.</p>"
                    : currentRequest?.requestForMe
                    ? labels?.WELFARE_BORSE_WON_MSG ||
                      "<p>Caro collega,<br/>siamo felici di comunicarti che grazie ai tuoi meriti e al tuo impegno, ti sei aggiudicato la borsa di studio.</p>"
                    : labels?.WELFARE_BORSE_WON_MSG_CHILD ||
                      "<p>Ciao,<br/>siamo felici di comunicarti che grazie ai tuoi meriti e al tuo impegno, ti sei aggiudicato la borsa di studio.</p>",
                }}
              />
              {/* <div
                className="app-content__text"
                dangerouslySetInnerHTML={{
                  __html: (
                    labels?.WELFARE_BORSE_WON_DESCR ||
                    "<strong>Ti verrà finanziata una borsa di studio pari a € [AMOUNT]</strong>"
                  ).replace("[AMOUNT]", currentRequest?.prizeAmount || "N/A"),
                }}
              />
              {currentRequest?.refundAmount && (
                <div
                  className="app-content__text"
                  dangerouslySetInnerHTML={{
                    __html: (
                      labels?.WELFARE_BORSE_WON_REFUND_DESCR ||
                      "<strong>Ti verrà riconosciuto un rimborso delle tasse universitarie pari a € [AMOUNT]</strong>"
                    ).replace("[AMOUNT]", currentRequest.refundAmount),
                  }}
                />
              )} */}
            </>
          ),
          NOT_ASSIGNED: (
            <>
              <div
                className="app-content__text"
                dangerouslySetInnerHTML={{
                  __html: currentRequest?.requestForMe
                    ? labels?.WELFARE_BORSE_REJECTED_MSG ||
                      "<p>Caro collega,<br/>ci dispiace ma la tua domanda non rispondeva ai requisiti richiesti, consapevoli però che continuerai ad impegnarti nel tuo percorso.</p>"
                    : labels?.WELFARE_BORSE_REJECTED_MSG_CHILD ||
                      "<p>Ciao,<br/>ci dispiace ma la tua domanda non rispondeva ai requisiti richiesti, consapevoli però che continuerai ad impegnarti nel tuo percorso.</p>",
                }}
              />
              {/* <div
                className="app-content__text"
                dangerouslySetInnerHTML={{
                  __html: (
                    labels?.WELFARE_BORSE_REJECTED_DESCR ||
                    "<strong>Motivazione: [EXPLANATION]</strong>"
                  ).replace("[EXPLANATION]", currentRequest?.rejectionNotes || "N/A"),
                }}
              /> */}
            </>
          ),
        }[currentRequest?.status]
      }
    </div>
  );
};

export default RequestOutcome;
